//Listings Map
(function () {
    var map;
    var element;
    var icon;
    var bounds;
    var infowindow;
    var markers = [];
    var firstTimeReload = true;
    var markerCluster;
    var markersLastBoundsChanged = [];
    var markersBeingShown = [];

    var reloadListings = function () {
        if (!firstTimeReload) {
            var res = hasAnyMarkerLeftTheMap();
            if(res) {
                MLSController.loadListings();
            }
        }

        firstTimeReload = false;
    };

    var init = function () {
        firstTimeReload = true;
        element = document.getElementById('listings-map');

        icon = element.getAttribute('data-icon');

        var styledMapType = new google.maps.StyledMapType(
            [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#444444"}]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [{"color": "#f2f2f2"}]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [{"visibility": "off"}]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [{"saturation": -100}, {"lightness": 45}]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [{"visibility": "simplified"}]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [{"visibility": "off"}]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [{"visibility": "off"}]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [{"color": "#46bcec"}, {"visibility": "on"}]
                }
            ],
            {name: 'Map'});

        map = new google.maps.Map(element, {
           /* center: {lat: 45.783286, lng: -108.500690},*/
            zoom: 14,
            gestureHandling: 'greedy',
            mapTypeControlOptions: {
                mapTypeIds: ['styled_map', 'hybrid']
            }
        });

        map.mapTypes.set('styled_map', styledMapType);
        map.setMapTypeId('styled_map');

        infowindow = new google.maps.InfoWindow();

        bounds = new google.maps.LatLngBounds();

        //Change label from Hybrid to Satellite
        google.maps.event.addListenerOnce(map,'idle',function () {
            map.mapTypes.hybrid.name='Satellite';
            map.setOptions({'mapTypeControl':true});
        });

        // Watch for changes to the bounds, get any properties within the bounds
        google.maps.event.addListener(map, 'bounds_changed', function () {
            if(!MapController.Listings.isSearch) {
                clearTimeout(MapController.Listings.listingsTimer);

                var bounds = map.getBounds();

                if (bounds) {
                    var sw = map.getBounds().getSouthWest();
                    var ne = map.getBounds().getNorthEast();


                    // compare the lat/lng to see if things changed
                    if (
                        (MapController.Listings.bounds.swLat !== sw.lat() || MapController.Listings.bounds.swLng !== sw.lng() ||
                            MapController.Listings.bounds.neLat !== ne.lat() || MapController.Listings.bounds.neLng !== ne.lng()) &&
                        MapController.Listings.bounds.swLat !== 0 && MapController.Listings.bounds.swLng !== 0 &&
                        MapController.Listings.bounds.neLat !== 0 && MapController.Listings.bounds.neLng !== 0) {
                        MapController.Listings.bounds.swLat = sw.lat();
                        MapController.Listings.bounds.swLng = sw.lng();
                        MapController.Listings.bounds.neLat = ne.lat();
                        MapController.Listings.bounds.neLng = ne.lng();
                        MapController.Listings.boundsChanged = true;
                    }
                }

                $('.list-results > article').addClass('hide');

                MapController.Listings.markerRange = [];

                markersBeingShown = [];

                for (var i = 0; i < markers.length; i++) {
                    if (map.getBounds().contains(markers[i].getPosition())) {
                        showListing(markers[i].propertyId);
                        markersBeingShown.push(markers[i]);
                    }
                }

                // load listings based on the new bounds
                MapController.Listings.listingsTimer = setTimeout(reloadListings, 500);

                MapController.Listings.initialLoadListings = false;

                reinitSlimScroll();
            }

            MapController.Listings.isSearch = false;
        });
    };

    var hasAnyMarkerLeftTheMap =function() {
        var markersNow = [];

        if(markersLastBoundsChanged.length === 0) {
            markersLastBoundsChanged = markers;
        }

        for (var i = 0; i < markers.length; i++) {
            if(map.getBounds().contains(markers[i].getPosition())) {
                markersNow.push(markers[i]);
            }
        }

        var result = markersLastBoundsChanged.length !== markersBeingShown.length;

        markersLastBoundsChanged = markersNow;

        $('[data-ref=total_of_listings]').attr('data-total-markers', markersLastBoundsChanged.length);

        return result;
    };

    var reinitSlimScroll = function() {
        if( $("#results .wrapper").length > 0) {
            $("#results .wrapper").slimScroll({
                height: 'auto',
                distance: '0',
                railBorderRadius: '0',
                railVisible: true,
                alwaysVisible: true,
                touchScrollStep: 50
            });
        }
    };

    var showListing = function (listing_id) {
        return $("article[data-id='" + listing_id + "']").removeClass('hide');
    };

    var addListing = function (propertyInstance) {

        // If property boundaries is not present, then get the lat/lng from the address.
        if (propertyInstance.latitude === null || propertyInstance.longitude === null || propertyInstance.latitude === "" || propertyInstance.longitude === "") {
            // Verify that address is there.  If it's not, just stop here.
            if (!propertyInstance.street_address ||
                !propertyInstance.city ||
                !propertyInstance.state ||
                !propertyInstance.zipcode) {
                return;
            }

            var gUrl = "https://maps.googleapis.com/maps/api/geocode/json",
                gAddress = "?address=" + propertyInstance.street_address,
                gCity = " " + propertyInstance.city,
                gState = " " + propertyInstance.state,
                gZip = " " + propertyInstance.zipcode,
                gKey = "&key=AIzaSyDYb9Bc-pOz1h61georfV3hu9c4K8iXEdA";

            gUrl = encodeURI(gUrl + gAddress + gCity + gState + gZip + gKey);

            $.ajax({
                type: 'GET',
                url: gUrl,
                async:false,
                success: function (data) {
                    if (data.status === "OK") {
                        var result = data.results[0];
                        var latLng = result.geometry.location;

                        propertyInstance.latitude=latLng.lat;
                        propertyInstance.longitude=latLng.lng;

                        propertyInstance.property_boundaries = {
                            map_center: {
                                lat: latLng.lat,
                                lng: latLng.lng
                            }
                        };

                        saveMarkerCenter(propertyInstance.property_boundaries, propertyInstance.comp_id);
                        buildListing(propertyInstance);
                    }
                }
            });
        } else {
            // If the instance is there, proceed as normal
            buildListing(propertyInstance);
        }
    };

    function saveMarkerCenter(data, id) {
        if (data.map_center.lat && data.map_center.lng) {
            $.post($("body").data("base-url") + "mls/save_property_boundaries/" + id,
                {property_boundaries: data, id: id});
        }
    }

    function buildListing(propertyInstance) {
        //Create a marker with the property template
        var marker = new google.maps.Marker
        (
            {
                position:
                    new google.maps.LatLng
                    (
                        propertyInstance.latitude,
                        propertyInstance.longitude
                    ),
                map: map,
                icon: icon,
                propertyId: propertyInstance.id
            }
        );


            //Capture click event and open marker's info window
        marker.addListener('click', function () {
            infowindow.close();
            var propertyId = this.get('propertyId');
            $.ajax({
                url: $("body").data("base-url") + 'mls/get_one_property_details',
                data: {propertyId: propertyId},
                success: function (responseText) {
                    var res =  JSON.parse(responseText);

                    if(res.property.id) {
                        var template = document.getElementById("map-info-windows").cloneNode(true);
                        template.classList.remove("hide");

                        var buildingSize = res.property.building_size;

                        if (res.property.building_size_suites_parcels && res.property.building_size_suites_parcels.length > 0 && parseInt(res.property.building_size_suites_parcels) !== 0) {
                            res.property.building_size = res.property.building_size_suites_parcels;
                        }

                        if (typeof res.property.listing_type === 'string' && Utils.contains(res.property.listing_type, 'sale') && Utils.contains(res.property.listing_type, 'lease') && buildingSize) {
                            res.property.building_size = buildingSize;
                        }

                        var askingPrice = res.property.asking_price;
                        if (typeof res.property.listing_type === 'string' && res.property.listing_type.toLowerCase() === 'lease' && res.property.asking_price_psf !== null) {
                            res.property.asking_price = res.property.asking_price_psf;
                        } else if (typeof res.property.listing_type === 'string' && res.property.listing_type.toLowerCase() === 'sale' && res.property.asking_price !== null) {
                            res.property.asking_price = askingPrice;
                        } else if (typeof res.property.listing_type === 'string' && Utils.contains(res.property.listing_type, 'sale') && Utils.contains(res.property.listing_type, 'lease')) {
                            if (res.property.asking_price_psf !== null) {
                                res.property.asking_price = res.property.asking_price_psf;
                            } else if (res.property.asking_price !== null) {
                                res.property.asking_price = askingPrice;
                            } else {
                                res.property.asking_price = 'Price Not Disclosed';
                            }
                        } else {
                            res.property.asking_price = 'Price Not Disclosed';
                        }

                        if (res.property.asking_price === 'Price Not Disclosed' && res.property.building_price_suites_parcels && parseInt(res.property.building_price_suites_parcels.replace(/\D/g, '')) > 0) {
                            res.property.asking_price = res.property.building_price_suites_parcels;
                        }

                        res.property.listing_image_url = Utils.imageUrl(res.property.listing_image_url);

                        template = MLSController.fill(res.property, template.outerHTML);

                        infowindow.setContent(template);

                        infowindow.addListener('domready', function () {
                            var content = document.querySelector('.gm-style-iw');
                            var mapInfoWindow = document.querySelector('#map-info-windows');

                            if (content.nextElementSibling) {
                                content.parentNode.removeChild(content.nextElementSibling);
                            }
                            content.style.setProperty('width', 'auto', 'important');
                            content.style.setProperty('right', content.style.left, 'important');
                            content.style.setProperty('text-align', 'center', 'important');
                            $(content).find('button').remove();

                            var closeBtn = $('#iw-close-btn').get();

                            google.maps.event.addDomListener(closeBtn[0], 'click', function () {
                                infowindow.close();
                            });
                        });

                        infowindow.open(map, marker);
                    }
                }
            });
        });

        markers.push(marker);

        bounds.extend(marker.position);
    }

    function clearMarkers() {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        if(markerCluster) {
            markerCluster.clearMarkers();
        }
        setDefault();
    }

    function resetMarkers() {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }

        markers = [];

        if(markerCluster) {
            markerCluster.clearMarkers();
        }
    }

    function setDefault() {
        markers = [];
        bounds = new google.maps.LatLngBounds();
        map.setCenter(Utils.getUSACenter());
        map.setZoom(4);
    }

    var getMap = function () {
        return map;
    };

    var checkMap = function () {
        // Group markers
        try{
            markerCluster = new MarkerClusterer(map, markers,
            {
                imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                minimumClusterSize: 4,
                maxZoom: 15
            });
            if (markers.length === 0) {
                setDefault();
            }
        }catch(e){
            setDefault();
        }
    };

    var fitBounds = function() {
        map.fitBounds(bounds);

        if (map.getZoom() > 20) {
            map.setZoom(20);
        }
    };

    var getImage = function (address, city, state, id) {
        var imageDim = {height: 640, width: 640};
        var size = imageDim.width + "x" + imageDim.height;
        var zoom = 16;
        var type = 'hybrid';
        var icon = document.getElementById('listings-map').getAttribute('data-icon');
        var center = address + " " + city + " " + state;
        center = center.replace(/ /g, "+");
        var url = "https://maps.googleapis.com/maps/api/staticmap?size=" + size + "&zoom=" + zoom + "&center=" + center + "&maptype=" + type + "&markers=icon:" + icon + "|" + center + "&key=" + MapController.getKey();

        if(id) {
            $.post($('body').attr('data-base-url') + "mls/saveMapImage", {id:id, url:url}, function( data ) {
                $( ".result" ).html( data );
            });
        }

        return url;
    };

    if (MapController.Listings === undefined) {
        MapController.Listings = {};
    }

    MapController.Listings.init = init;
    MapController.Listings.getMap = getMap;
    MapController.Listings.clean = clearMarkers;
    MapController.Listings.resetMarkers = resetMarkers;
    MapController.Listings.addListing = addListing;
    MapController.Listings.checkMap = checkMap;
    MapController.Listings.getImage = getImage;
    MapController.Listings.fitBounds = fitBounds;
    MapController.Listings.bounds = {
        swLat: null,
        swLng: null,
        neLat: null,
        neLng: null
    };
    MapController.Listings.listingsTimer = null;
    MapController.Listings.firstBounds = true;
    MapController.Listings.boundsChanged = false;
    MapController.Listings.markersSet = false;
    MapController.Listings.initialLoadListings = true;
    MapController.Listings.isSearch = false;
})();
